import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const PAYSLIP_SHOW = "payslip/show";

export const showPayslip = createAsyncThunk(
  PAYSLIP_SHOW,
  async (payload, thunkAPI) => {
    try {
      const payslip = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}GetPayslips(${payload})`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return payslip;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
